import React, { useState, useEffect } from "react";
import HeaderDashboard from "../../../components/HeaderDashboard";
import { Button, Chip, Divider, Breadcrumbs, Link } from "@mui/material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { gerarLinkWhatsApp } from "../../../../utils/WhatsappLink";
import { useUser } from "../../../../contexts/UserContext";
import { useNavigate } from 'react-router-dom';
import {
    Alert,
    Box,
    Grid,
    Paper,
    Typography,
} from "@mui/material";

import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HomeIcon from '@mui/icons-material/Home';
import ArtTrackIcon from '@mui/icons-material/ArtTrack';

const ResidenciaFiscal = () => {

    const { user } = useUser();
    const navigate = useNavigate();

    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);

    const handleCancelarEnderecoFiscal = () => {
        window.open(gerarLinkWhatsApp("Olá, gostaria de solicitar o cancelamento do endereço fiscal da minha empresa."), "_blank");
    }

    console.log("User data:", user);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])


    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={0} />
            <Box sx={{ p: 4, background: "#f4f6f8", minHeight: "100vh", mt: "64px" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
                    <div style={{ width: "80%" }}>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                color="inherit"
                                onClick={() => navigate("../dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Typography
                                sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                            >
                                <ArtTrackIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Endereço Fiscal
                            </Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <Box
                    sx={{
                        maxWidth: 1100,
                        mx: "auto",
                        mt: 8,
                        px: 2,
                        pb: 5,
                    }}
                >
                    <Paper
                        elevation={0}
                        sx={{
                            borderRadius: 4,
                            p: 4,
                            border: "1px solid #ECECEC",
                            mb: 3,
                        }}
                    >
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            flexWrap="wrap"
                            gap={2}
                        >
                            <Box display="flex" alignItems="center" gap={2}>
                                <LocationOnIcon
                                    sx={{
                                        fontSize: 40,
                                        color: "#9C01B9",
                                    }}
                                />

                                <Box>
                                    <Typography
                                        variant="h5"
                                        fontWeight={700}
                                    >
                                        Endereço Fiscal
                                    </Typography>

                                    <Typography color="text.secondary">
                                        Gerencie sua assinatura do endereço fiscal.
                                    </Typography>
                                </Box>
                            </Box>

                            <Chip
                                color="success"
                                icon={<CheckCircleOutlineIcon />}
                                label="Ativo"
                            />
                        </Box>

                        <Divider sx={{ my: 3 }} />

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Typography variant="caption">
                                    ENDEREÇO
                                </Typography>

                                <Typography fontWeight={600}>
                                    {user?.enderecoFiscal?.rua}, {user?.enderecoFiscal?.numero} - {user?.enderecoFiscal?.bairro}
                                </Typography>

                                <Typography color="text.secondary">
                                    {user?.enderecoFiscal?.cidade} • {user?.enderecoFiscal?.estado}
                                </Typography>

                                <Typography color="text.secondary">
                                    CEP {user?.enderecoFiscal?.cep}
                                </Typography>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Typography variant="caption">
                                    INFORMAÇÕES DA ASSINATURA
                                </Typography>

                                <Typography>
                                    Contratado em <strong>{new Date(user?.assinaturaEnderecoFiscal?.dataContratacao).toLocaleDateString("pt-BR")}</strong>
                                </Typography>

                                <Typography>
                                    Método: <strong>{user?.assinaturaEnderecoFiscal?.metodoPagamento}</strong>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>

                    <Paper
                        elevation={0}
                        sx={{
                            borderRadius: 4,
                            border: "1px solid #ECECEC",
                            p: 4,
                        }}
                    >
                        <Box display="flex" gap={2}>
                            <InfoOutlinedIcon
                                sx={{
                                    color: "#9C01B9",
                                    mt: .4,
                                }}
                            />

                            <Box>
                                <Typography
                                    variant="h6"
                                    fontWeight={700}
                                >
                                    Sobre o cancelamento
                                </Typography>

                                <Typography
                                    sx={{
                                        mt: 2,
                                        color: "#666",
                                        lineHeight: 1.8,
                                    }}
                                >
                                    O endereço fiscal pode ser cancelado a qualquer
                                    momento, desde que sua empresa possua um novo
                                    endereço fiscal válido e seja realizada a alteração
                                    do contrato social.
                                </Typography>

                                <Alert
                                    severity="warning"
                                    sx={{
                                        mt: 3,
                                    }}
                                >
                                    O cancelamento interrompe as próximas cobranças,
                                    porém não altera automaticamente os dados da sua
                                    empresa junto aos órgãos competentes.
                                </Alert>

                                <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    mt={4}
                                >
                                    <Button
                                        variant="contained"
                                        color="error"
                                        startIcon={<CancelOutlinedIcon />}
                                        sx={{
                                            borderRadius: 3,
                                            px: 4,
                                        }}
                                        onClick={handleCancelarEnderecoFiscal}
                                    >
                                        Solicitar Cancelamento
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Paper>
                </Box>
            </Box>

        </>
    );
}

export default ResidenciaFiscal;